var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-button',{class:_vm.sassStyles.root,attrs:{"type":_vm.variant,"ghost":_vm.outline,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('button-click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }